import {Component, Inject, OnInit, Optional} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {IBankInfoCards} from 'src/app/interfaces/accountant.interfaces';
import {DIALOG_DATA} from 'src/app/services/dialog.service';
import {EmployeeService} from 'src/app/services/employee.service';
import {DialogRef} from 'src/app/shared/ui-kits/dialog/dialog-ref';

@UntilDestroy()
@Component({
  selector: 'app-card-number-popup',
  templateUrl: './card-number-popup.component.html',
  styleUrls: ['./card-number-popup.component.scss'],
})
export class CardNumberPopupComponent implements OnInit {
  public cardForm!: UntypedFormGroup;
  public isCreate = false;
  constructor(
    private _fb: UntypedFormBuilder,
    private dialogRef: DialogRef,
    private employee: EmployeeService,
    @Optional() @Inject(DIALOG_DATA) public data: IBankInfoCards
  ) {}

  ngOnInit(): void {
    if (!this.data.id) {
      this.isCreate = true;
    }
    this.cardForm = this._fb.group({
      id: new UntypedFormControl(this.data.id),
      bankInfoId: new UntypedFormControl(this.data.bankInfoId),
      cardNumber: new UntypedFormControl(this.data.cardNumber),
      endDate: new UntypedFormControl(this.data.endDate),
    });
  }

  save() {
    this.dialogRef.close(this.cardForm.value);
  }

  close() {
    this.dialogRef.close();
  }

  deleteCard() {
    if (!this.data.id) return;
    this.employee
      .deleteCard(this.data.id)
      .pipe(untilDestroyed(this))
      .subscribe(() => this.dialogRef.close('delete'));
  }
}
